import api from "services";
import * as actionTypes from "constants/ActionTypes";
import { takeLatest, call, put, take, fork, select } from "redux-saga/effects";

function* getIntegrators() {
  try {
    const integrators = yield call(api.getIntegrators);
    yield put({
      type: actionTypes.GET_INTEGRATORS.SUCCESS,
      data: integrators,
    });
  } catch (error) {
    yield put({
      type: actionTypes.GET_INTEGRATORS.FAILURE,
      errors: error,
    });
  }
}

function* getIntegratorCompanies(id) {
  try {
    const companies = yield call(api.getIntegratorCompanies, id);
    yield put({
      type: actionTypes.GET_INTEGRATOR_COMPANIES.SUCCESS,
      data: companies,
      id,
    });
  } catch (error) {
    yield put({
      type: actionTypes.GET_INTEGRATOR_COMPANIES.FAILURE,
      errors: error,
    });
  }
}
function* getCompanyUser(id, integratorId) {
  try {
    integratorId = integratorId
      ? integratorId
      : yield select(
          ({ integratorCompanies: { integratorId } }) => integratorId
        );
    const user = yield call(api.getCompanyUser, id, integratorId);
    yield put({
      type: actionTypes.GET_COMPANY_USER.SUCCESS,
      data: user,
      id,
    });
  } catch (error) {
    yield put({
      type: actionTypes.GET_COMPANY_USER.FAILURE,
      errors: error,
    });
  }
}

export function* watchGetCompanyUser() {
  while (true) {
    const { id, integratorId } = yield take(
      actionTypes.GET_COMPANY_USER.REQUEST
    );

    yield fork(getCompanyUser, id, integratorId);
  }
}

export function* watchGetIntegratorCompanies() {
  while (true) {
    const { id } = yield take(actionTypes.GET_INTEGRATOR_COMPANIES.REQUEST);
    yield fork(getIntegratorCompanies, id);
  }
}

export function* watchGetIntegrators() {
  yield takeLatest(actionTypes.GET_INTEGRATORS.REQUEST, getIntegrators);
}

export default [
  watchGetIntegrators,
  watchGetIntegratorCompanies,
  watchGetCompanyUser,
];



// WEBPACK FOOTER //
// ./app/sagas/integrators/integrators.js